import { render, staticRenderFns } from "./DetailFriend.vue?vue&type=template&id=5bac23c5&scoped=true&"
import script from "./DetailFriend.vue?vue&type=script&lang=js&"
export * from "./DetailFriend.vue?vue&type=script&lang=js&"
import style0 from "./DetailFriend.vue?vue&type=style&index=0&id=5bac23c5&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bac23c5",
  null
  
)

export default component.exports